(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6167],{

/***/ 67761:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/silver-price-calculator",
      function () {
        return __webpack_require__(51580);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 55542:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Calculator-Page.9b431956.jpg","height":2160,"width":4920,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAEAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAfEAABBAAHAAAAAAAAAAAAAAAAAQIDEQQSEyEiQWH/xAAVAQEBAAAAAAAAAAAAAAAAAAADBP/EABYRAQEBAAAAAAAAAAAAAAAAAAABMf/aAAwDAQACEQMRAD8Au2YVH6uaaZakVyc6rzboAEUw7//Z"});

/***/ }),

/***/ 99810:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/price-calculator.96fb4359.jpg","height":400,"width":432,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAHAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAYEAEAAwEAAAAAAAAAAAAAAAAAARESMf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCxzrXaAB//2Q=="});

/***/ }),

/***/ 51580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(47568);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _layout_layout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16559);
/* harmony import */ var _assets_images_Calculator_Page_jpg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55542);
/* harmony import */ var _assets_images_price_calculator_jpg__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99810);
/* harmony import */ var _gold_price_calculator_price_calculator_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(2505);
/* harmony import */ var _gold_price_calculator_price_calculator_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_gold_price_calculator_price_calculator_module_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(5607);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82175);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(74231);
/* harmony import */ var _api_http_client__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(55642);
/* harmony import */ var _api_endpoints__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3557);
/* eslint-disable react/no-unescaped-entities */ "use client";
















var validationSchema = yup__WEBPACK_IMPORTED_MODULE_9__/* .object */ .Ry({
    metal: yup__WEBPACK_IMPORTED_MODULE_9__/* .string */ .Z_().required("Metal selection is required"),
    purity: yup__WEBPACK_IMPORTED_MODULE_9__/* .string */ .Z_().required("Purity selection is required"),
    weight: yup__WEBPACK_IMPORTED_MODULE_9__/* .string */ .Z_().matches(/^\d+(\.\d{1,2})?$/, "Enter a valid weight (e.g., 1 or 1.5)").required("Weight is required"),
    amount: yup__WEBPACK_IMPORTED_MODULE_9__/* .string */ .Z_().matches(/^\d+(\.\d{1,2})?$/, "Enter a valid amount (e.g., 1320 or 1320.50)").required("Amount is required"),
    makingCharge: yup__WEBPACK_IMPORTED_MODULE_9__/* .string */ .Z_().matches(/^\d+(\.\d{1,2})?%$/, "Enter a valid percentage (e.g., 10%)").required("Making charge is required"),
    gst: yup__WEBPACK_IMPORTED_MODULE_9__/* .string */ .Z_().required("GST selection is required")
});
var PriceCalculator = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("price"), activeTab = ref[0], setActiveTab = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), metalData = ref1[0], setMetalData = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), loading = ref2[0], setLoading = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), error = ref3[0], setError = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), result = ref4[0], setResult = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), selectedUpdatedAt = ref5[0], setSelectedUpdatedAt = ref5[1];
    var initialValues = {
        metal: "SILVER",
        purity: "99.99",
        weight: "1",
        amount: "0",
        makingCharge: "10%",
        gst: "Yes"
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var fetchMetalData = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var response, defaultPurity;
                return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return _api_http_client__WEBPACK_IMPORTED_MODULE_10__/* ["default"].get */ .Z.get(_api_endpoints__WEBPACK_IMPORTED_MODULE_11__/* ["default"].calculator.list */ .Z.calculator.list());
                        case 3:
                            response = _ctx.sent;
                            setMetalData(response.data);
                            defaultPurity = response.data.SILVER.find(function(item) {
                                return item.name === "99.99";
                            });
                            if (defaultPurity) {
                                setSelectedUpdatedAt(defaultPurity.updated_at);
                            }
                            setLoading(false);
                            _ctx.next = 15;
                            break;
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](0);
                            setError("Failed to fetch metal data. Please try again later.");
                            setLoading(false);
                            ;
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        10
                    ]
                ]);
            }));
            return function fetchMetalData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchMetalData();
    }, []);
    var getPurityOptions = function(metal) {
        if (!metalData) return [];
        return metalData[metal] || [];
    };
    var calculate = function(values, tab) {
        var ref;
        if (!metalData) return {
            basePrice: 0,
            makingCharges: 0,
            gstAmount: 0,
            totalPrice: 0,
            weight: 0
        };
        var selectedPurity = (ref = metalData[values.metal]) === null || ref === void 0 ? void 0 : ref.find(function(item) {
            return item.name === values.purity;
        });
        if (!selectedPurity) return {
            basePrice: 0,
            makingCharges: 0,
            gstAmount: 0,
            totalPrice: 0,
            weight: 0
        };
        var pricePerGram = selectedPurity.price;
        var makingChargePercent = parseInt(values.makingCharge.replace("%", ""));
        var includeGST = values.gst === "Yes";
        if (tab === "price") {
            var weight = parseFloat(values.weight) || 0;
            var basePrice = weight * pricePerGram;
            var makingCharges = basePrice * makingChargePercent / 100;
            var totalPrice = basePrice + makingCharges;
            var gstAmount = includeGST ? totalPrice * 3 / 100 : 0;
            totalPrice += gstAmount;
            return {
                basePrice: basePrice,
                makingCharges: makingCharges,
                gstAmount: gstAmount,
                totalPrice: totalPrice,
                weight: weight
            };
        } else {
            var amount = parseFloat(values.amount) || 0;
            var amountExcludingGST = amount;
            if (includeGST) {
                amountExcludingGST = amount / 1.03;
            }
            var basePrice1 = amountExcludingGST;
            if (makingChargePercent > 0) {
                basePrice1 = amountExcludingGST / (1 + makingChargePercent / 100);
            }
            var weight1 = basePrice1 / pricePerGram;
            return {
                basePrice: basePrice1,
                makingCharges: amountExcludingGST - basePrice1,
                gstAmount: includeGST ? amount - amountExcludingGST : 0,
                totalPrice: amount,
                weight: weight1
            };
        }
    };
    var handleSubmit = function(values) {
        var calculationResult = calculate(values, activeTab);
        setResult(calculationResult);
    };
    var updateAmountFromWeight = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(values, setFieldValue) {
        var ref;
        if (activeTab !== "price") return;
        if (!metalData) return;
        var selectedPurity = (ref = metalData[values.metal]) === null || ref === void 0 ? void 0 : ref.find(function(item) {
            return item.name === values.purity;
        });
        if (!selectedPurity) return;
        var weight = parseFloat(values.weight) || 0;
        var pricePerGram = selectedPurity.price;
        var amount = (weight * pricePerGram).toFixed(2);
        setFieldValue("amount", amount);
        setSelectedUpdatedAt(selectedPurity.updated_at);
    }, [
        activeTab,
        metalData
    ]);
    var updateWeightFromAmount = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(values, setFieldValue) {
        var ref;
        if (activeTab !== "gram") return;
        if (!metalData) return;
        var selectedPurity = (ref = metalData[values.metal]) === null || ref === void 0 ? void 0 : ref.find(function(item) {
            return item.name === values.purity;
        });
        if (!selectedPurity) return;
        var amount = parseFloat(values.amount) || 0;
        var pricePerGram = selectedPurity.price;
        var weight = (amount / pricePerGram).toFixed(2);
        setFieldValue("weight", weight);
        setSelectedUpdatedAt(selectedPurity.updated_at);
    }, [
        activeTab,
        metalData
    ]);
    var PriceTabForm = function(param) {
        var values = param.values, setFieldValue = param.setFieldValue;
        (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
            updateAmountFromWeight(values, setFieldValue);
        }, [
            values.metal,
            values.purity,
            values.weight,
            setFieldValue,
            updateAmountFromWeight, 
        ]);
        (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
            if (metalData) {
                var goldItems = metalData.SILVER;
                var defaultPurity = goldItems.find(function(item) {
                    return item.name === "99.99";
                });
                if (defaultPurity) {
                    var weight = parseFloat(values.weight) || 0;
                    var amount = (weight * defaultPurity.price).toFixed(2);
                    setFieldValue("amount", amount);
                }
            }
        }, [
            metalData,
            setFieldValue,
            values.weight
        ]);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_8__/* .Form */ .l0, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "py-4",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "col-md-6 ",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h5", {
                                    className: "fw-bold mb-4 text-dark",
                                    children: "Calculator Input"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: "mb-3 row align-items-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
                                            className: "form-label mb-md-0 col-md-6",
                                            children: "Metal"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            className: "col-md-6",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_8__/* .Field */ .gN, {
                                                    as: "select",
                                                    name: "metal",
                                                    className: "form-select",
                                                    onChange: function(e) {
                                                        var selectedMetal = e.target.value;
                                                        if (selectedMetal === "GOLD") {
                                                            router.push("/gold-price-calculator");
                                                            return;
                                                        } else if (selectedMetal === "PLATINUM") {
                                                            router.push("/platinum-price-calculator");
                                                            return;
                                                        }
                                                        setFieldValue("metal", selectedMetal);
                                                        var purities = getPurityOptions(selectedMetal);
                                                        if (purities.length > 0) {
                                                            setFieldValue("purity", purities[0].name);
                                                            setSelectedUpdatedAt(purities[0].updated_at);
                                                        }
                                                    },
                                                    children: metalData && Object.keys(metalData).map(function(metal) {
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("option", {
                                                            value: metal,
                                                            children: metal
                                                        }, metal);
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_8__/* .ErrorMessage */ .Bc, {
                                                    name: "metal",
                                                    component: "div",
                                                    className: "text-danger"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: "mb-3 row align-items-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
                                            className: "form-label mb-md-0 col-md-6",
                                            children: "Purity"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            className: "col-md-6",
                                            children: [
                                                getPurityOptions(values.metal).map(function(item) {
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                        className: "form-check form-check-inline",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_8__/* .Field */ .gN, {
                                                                type: "radio",
                                                                name: "purity",
                                                                value: item.name,
                                                                className: "form-check-input",
                                                                id: "purity-".concat(item.name),
                                                                onChange: function() {
                                                                    setFieldValue("purity", item.name);
                                                                    setSelectedUpdatedAt(item.updated_at);
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("label", {
                                                                className: "form-check-label",
                                                                htmlFor: "purity-".concat(item.name),
                                                                children: [
                                                                    item.display_name,
                                                                    " (",
                                                                    item.name,
                                                                    ")"
                                                                ]
                                                            })
                                                        ]
                                                    }, item.name);
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_8__/* .ErrorMessage */ .Bc, {
                                                    name: "purity",
                                                    component: "div",
                                                    className: "text-danger"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: "mb-3 row align-items-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
                                            className: "form-label mb-md-0 col-md-6 pt-md-3",
                                            children: "Weight of Metal (in gm)"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            className: "col-md-6",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                    className: (_gold_price_calculator_price_calculator_module_scss__WEBPACK_IMPORTED_MODULE_13___default().input_group),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                            className: (_gold_price_calculator_price_calculator_module_scss__WEBPACK_IMPORTED_MODULE_13___default().text_input),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                                    className: (_gold_price_calculator_price_calculator_module_scss__WEBPACK_IMPORTED_MODULE_13___default().pleft),
                                                                    children: "Gram"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_8__/* .Field */ .gN, {
                                                                    type: "text",
                                                                    name: "weight",
                                                                    className: "form-control",
                                                                    onChange: function(e) {
                                                                        setFieldValue("weight", e.target.value);
                                                                    }
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                            className: (_gold_price_calculator_price_calculator_module_scss__WEBPACK_IMPORTED_MODULE_13___default().arrow_swip),
                                                            children: "⇋"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                            className: (_gold_price_calculator_price_calculator_module_scss__WEBPACK_IMPORTED_MODULE_13___default().text_input),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                                    className: (_gold_price_calculator_price_calculator_module_scss__WEBPACK_IMPORTED_MODULE_13___default().pleft),
                                                                    children: "Amount"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_8__/* .Field */ .gN, {
                                                                    type: "text",
                                                                    name: "amount",
                                                                    className: "form-control",
                                                                    readOnly: true,
                                                                    style: {
                                                                        backgroundColor: "#e9ecef",
                                                                        cursor: "not-allowed"
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_8__/* .ErrorMessage */ .Bc, {
                                                    name: "weight",
                                                    component: "div",
                                                    className: "text-danger"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_8__/* .ErrorMessage */ .Bc, {
                                                    name: "amount",
                                                    component: "div",
                                                    className: "text-danger"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: "mb-3 row align-items-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
                                            className: "form-label mb-md-0 col-md-6",
                                            children: "Making Charge"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            className: "col-md-6",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    className: "input-group",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_8__/* .Field */ .gN, {
                                                        type: "text",
                                                        name: "makingCharge",
                                                        className: "form-control",
                                                        onChange: function(e) {
                                                            var value = e.target.value.replace(/[^0-9.]/g, "");
                                                            if (value === "") {
                                                                value = "0";
                                                            }
                                                            value = "".concat(value, "%");
                                                            setFieldValue("makingCharge", value);
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_8__/* .ErrorMessage */ .Bc, {
                                                    name: "makingCharge",
                                                    component: "div",
                                                    className: "text-danger"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: "mb-3 row align-items-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("label", {
                                            className: "form-label mb-md-0 col-md-6",
                                            children: [
                                                "GST ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("small", {
                                                    children: "(3%)"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            className: "col-md-6",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                    className: "form-check form-check-inline",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_8__/* .Field */ .gN, {
                                                            type: "radio",
                                                            name: "gst",
                                                            value: "Yes",
                                                            className: "form-check-input"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
                                                            className: "form-check-label",
                                                            children: "Yes"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                    className: "form-check form-check-inline",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_8__/* .Field */ .gN, {
                                                            type: "radio",
                                                            name: "gst",
                                                            value: "No",
                                                            className: "form-check-input"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
                                                            className: "form-check-label",
                                                            children: "No"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_8__/* .ErrorMessage */ .Bc, {
                                                    name: "gst",
                                                    component: "div",
                                                    className: "text-danger"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                    type: "submit",
                                    className: (_gold_price_calculator_price_calculator_module_scss__WEBPACK_IMPORTED_MODULE_13___default().calculate_btn),
                                    children: "Calculate now"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "col-md-6 ",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h5", {
                                    className: "fw-bold mb-4 text-dark mt-4 mt-md-0",
                                    children: "Calculator Output"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: (_gold_price_calculator_price_calculator_module_scss__WEBPACK_IMPORTED_MODULE_13___default().calculator_output),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: "w-100 text-center",
                                        children: result ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                                    className: "mb-1",
                                                    children: [
                                                        values.weight,
                                                        " Gram of ",
                                                        values.metal,
                                                        " Total Price"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("h3", {
                                                    className: "text-dark",
                                                    children: [
                                                        "₹ ",
                                                        result.totalPrice.toFixed(2)
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                            className: "text-muted",
                                            children: "Click Calculate now to see results"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        });
    };
    var GramTabForm = function(param) {
        var values = param.values, setFieldValue = param.setFieldValue;
        (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
            updateWeightFromAmount(values, setFieldValue);
        }, [
            values.metal,
            values.purity,
            values.amount,
            setFieldValue,
            updateWeightFromAmount, 
        ]);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_8__/* .Form */ .l0, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "py-4",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "col-md-6 ",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h5", {
                                    className: "fw-bold mb-4 text-dark",
                                    children: "Calculator Input"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: "mb-3 row align-items-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
                                            className: "form-label mb-md-0 col-md-6",
                                            children: "Metal"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            className: "col-md-6",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_8__/* .Field */ .gN, {
                                                    as: "select",
                                                    name: "metal",
                                                    className: "form-select",
                                                    onChange: function(e) {
                                                        var selectedMetal = e.target.value;
                                                        if (selectedMetal === "GOLD") {
                                                            router.push("/gold-price-calculator");
                                                            return;
                                                        } else if (selectedMetal === "PLATINUM") {
                                                            router.push("/platinum-price-calculator");
                                                            return;
                                                        }
                                                        setFieldValue("metal", selectedMetal);
                                                        var purities = getPurityOptions(selectedMetal);
                                                        if (purities.length > 0) {
                                                            setFieldValue("purity", purities[0].name);
                                                            setSelectedUpdatedAt(purities[0].updated_at);
                                                        }
                                                    },
                                                    children: metalData && Object.keys(metalData).map(function(metal) {
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("option", {
                                                            value: metal,
                                                            children: metal
                                                        }, metal);
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_8__/* .ErrorMessage */ .Bc, {
                                                    name: "metal",
                                                    component: "div",
                                                    className: "text-danger"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: "mb-3 row align-items-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
                                            className: "form-label mb-md-0 col-md-6",
                                            children: "Purity"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            className: "col-md-6",
                                            children: [
                                                getPurityOptions(values.metal).map(function(item) {
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                        className: "form-check form-check-inline",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_8__/* .Field */ .gN, {
                                                                type: "radio",
                                                                name: "purity",
                                                                value: item.name,
                                                                className: "form-check-input",
                                                                id: "purity-".concat(item.name),
                                                                onChange: function() {
                                                                    setFieldValue("purity", item.name);
                                                                    setSelectedUpdatedAt(item.updated_at);
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
                                                                className: "form-check-label",
                                                                htmlFor: "purity-".concat(item.name),
                                                                children: item.display_name
                                                            })
                                                        ]
                                                    }, item.name);
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_8__/* .ErrorMessage */ .Bc, {
                                                    name: "purity",
                                                    component: "div",
                                                    className: "text-danger"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: "mb-3 row align-items-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
                                            className: "form-label mb-md-0 col-md-6 pt-md-3",
                                            children: "Weight of Metal (in gm)"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            className: "col-md-6",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                    className: (_gold_price_calculator_price_calculator_module_scss__WEBPACK_IMPORTED_MODULE_13___default().input_group),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                            className: (_gold_price_calculator_price_calculator_module_scss__WEBPACK_IMPORTED_MODULE_13___default().text_input),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                                    className: (_gold_price_calculator_price_calculator_module_scss__WEBPACK_IMPORTED_MODULE_13___default().pleft),
                                                                    children: "Gram"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_8__/* .Field */ .gN, {
                                                                    type: "text",
                                                                    name: "weight",
                                                                    className: "form-control",
                                                                    readOnly: true,
                                                                    style: {
                                                                        backgroundColor: "#e9ecef",
                                                                        cursor: "not-allowed"
                                                                    }
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                            className: (_gold_price_calculator_price_calculator_module_scss__WEBPACK_IMPORTED_MODULE_13___default().arrow_swip),
                                                            children: "⇋"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                            className: (_gold_price_calculator_price_calculator_module_scss__WEBPACK_IMPORTED_MODULE_13___default().text_input),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                                    className: (_gold_price_calculator_price_calculator_module_scss__WEBPACK_IMPORTED_MODULE_13___default().pleft),
                                                                    children: "Amount"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_8__/* .Field */ .gN, {
                                                                    type: "text",
                                                                    name: "amount",
                                                                    className: "form-control",
                                                                    onChange: function(e) {
                                                                        setFieldValue("amount", e.target.value);
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_8__/* .ErrorMessage */ .Bc, {
                                                    name: "weight",
                                                    component: "div",
                                                    className: "text-danger"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_8__/* .ErrorMessage */ .Bc, {
                                                    name: "amount",
                                                    component: "div",
                                                    className: "text-danger"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: "mb-3 row align-items-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
                                            className: "form-label mb-md-0 col-md-6",
                                            children: "Making Charge"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            className: "col-md-6",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    className: "input-group",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_8__/* .Field */ .gN, {
                                                        type: "text",
                                                        name: "makingCharge",
                                                        className: "form-control",
                                                        onChange: function(e) {
                                                            var value = e.target.value.replace(/[^0-9.]/g, "");
                                                            if (value === "") {
                                                                value = "0";
                                                            }
                                                            value = "".concat(value, "%");
                                                            setFieldValue("makingCharge", value);
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_8__/* .ErrorMessage */ .Bc, {
                                                    name: "makingCharge",
                                                    component: "div",
                                                    className: "text-danger"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: "mb-3 row align-items-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("label", {
                                            className: "form-label mb-md-0 col-md-6",
                                            children: [
                                                "GST ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("small", {
                                                    children: "(3%)"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            className: "col-md-6",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                    className: "form-check form-check-inline",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_8__/* .Field */ .gN, {
                                                            type: "radio",
                                                            name: "gst",
                                                            value: "Yes",
                                                            className: "form-check-input"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
                                                            className: "form-check-label",
                                                            children: "Yes"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                    className: "form-check form-check-inline",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_8__/* .Field */ .gN, {
                                                            type: "radio",
                                                            name: "gst",
                                                            value: "No",
                                                            className: "form-check-input"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
                                                            className: "form-check-label",
                                                            children: "No"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_8__/* .ErrorMessage */ .Bc, {
                                                    name: "gst",
                                                    component: "div",
                                                    className: "text-danger"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                    type: "submit",
                                    className: (_gold_price_calculator_price_calculator_module_scss__WEBPACK_IMPORTED_MODULE_13___default().calculate_btn),
                                    children: "Calculate now"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "col-md-6 ",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h5", {
                                    className: "fw-bold mb-4 text-dark mt-4 mt-md-0",
                                    children: "Calculator Output"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: (_gold_price_calculator_price_calculator_module_scss__WEBPACK_IMPORTED_MODULE_13___default().calculator_output),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: "w-100 text-center",
                                        children: result ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                                    className: "mb-1",
                                                    children: [
                                                        "₹ ",
                                                        values.amount,
                                                        " of ",
                                                        values.metal,
                                                        " Total Weight"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("h3", {
                                                    className: "text-dark",
                                                    children: [
                                                        result.weight.toFixed(2),
                                                        " Gram"
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                            className: "text-muted",
                                            children: "Click Calculate now to see results"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        });
    };
    if (loading) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_layout_layout__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "text-center py-5",
                children: "Loading..."
            })
        });
    }
    if (error) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_layout_layout__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "text-center py-5 text-danger",
                children: error
            })
        });
    }
    if (!metalData) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_layout_layout__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "text-center py-5",
                children: "No data available"
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_layout_layout__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: (_gold_price_calculator_price_calculator_module_scss__WEBPACK_IMPORTED_MODULE_13___default().banner),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                    src: _assets_images_Calculator_Page_jpg__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
                    alt: "Price Calculator Banner"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: (_gold_price_calculator_price_calculator_module_scss__WEBPACK_IMPORTED_MODULE_13___default().calculating_heading_main),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
                        className: (_gold_price_calculator_price_calculator_module_scss__WEBPACK_IMPORTED_MODULE_13___default().calculating_heading),
                        children: "Silver Price Calculator"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: (_gold_price_calculator_price_calculator_module_scss__WEBPACK_IMPORTED_MODULE_13___default().calculator_bg_main),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "container pb-5",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: (_gold_price_calculator_price_calculator_module_scss__WEBPACK_IMPORTED_MODULE_13___default().calculator_card),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: (_gold_price_calculator_price_calculator_module_scss__WEBPACK_IMPORTED_MODULE_13___default().calculator_blink),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: (_gold_price_calculator_price_calculator_module_scss__WEBPACK_IMPORTED_MODULE_13___default().calculator_blink_text),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: (_gold_price_calculator_price_calculator_module_scss__WEBPACK_IMPORTED_MODULE_13___default().live),
                                                children: "Prices updated @"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: (_gold_price_calculator_price_calculator_module_scss__WEBPACK_IMPORTED_MODULE_13___default().calculator_blink_text_price),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                    className: (_gold_price_calculator_price_calculator_module_scss__WEBPACK_IMPORTED_MODULE_13___default().blink),
                                                    children: selectedUpdatedAt
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("ul", {
                                    className: "nav",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                            className: "nav-item",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                                className: "nav-link ".concat(activeTab === "price" ? "active" : ""),
                                                onClick: function() {
                                                    return setActiveTab("price");
                                                },
                                                children: "Calculate Price"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                            className: "nav-item",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                                className: "nav-link ".concat(activeTab === "gram" ? "active" : ""),
                                                onClick: function() {
                                                    return setActiveTab("gram");
                                                },
                                                children: "Calculate Gram"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: "w-100 p-md-4",
                                    children: [
                                        activeTab === "price" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_8__/* .Formik */ .J9, {
                                            initialValues: initialValues,
                                            validationSchema: validationSchema,
                                            onSubmit: handleSubmit,
                                            children: function(param) {
                                                var values = param.values, setFieldValue = param.setFieldValue;
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PriceTabForm, {
                                                    values: values,
                                                    setFieldValue: setFieldValue
                                                });
                                            }
                                        }),
                                        activeTab === "gram" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_8__/* .Formik */ .J9, {
                                            initialValues: initialValues,
                                            validationSchema: validationSchema,
                                            onSubmit: handleSubmit,
                                            children: function(param) {
                                                var values = param.values, setFieldValue = param.setFieldValue;
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(GramTabForm, {
                                                    values: values,
                                                    setFieldValue: setFieldValue
                                                });
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: (_gold_price_calculator_price_calculator_module_scss__WEBPACK_IMPORTED_MODULE_13___default().calculator_image),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                            src: _assets_images_price_calculator_jpg__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,
                            alt: "Price Calculator"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: (_gold_price_calculator_price_calculator_module_scss__WEBPACK_IMPORTED_MODULE_13___default().calculator_footer),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                            className: (_gold_price_calculator_price_calculator_module_scss__WEBPACK_IMPORTED_MODULE_13___default().calculator_footer_text_head),
                            children: "Live Silver Price Calculator"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                            className: "mb-4",
                            children: "When buying or valuing silver, understanding the price per gram is essential. Whether you’re planning to buy silver jewellery, invest in silver coins, or sell your silver items, knowing the silver cost gram can help you make well-informed decisions. Given that silver prices fluctuate daily, a calculator designed to estimate silver’s value becomes a practical and time-saving tool."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                            className: "mb-4",
                            children: "A silver price calculator helps you determine the estimated value of your silver based on real-time rates, weight, and purity. Instead of manually calculating costs or relying on uncertain quotes, this tool gives an instant and approximate value of your silver in Indian Rupees (INR). Read on to know more."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "mt-3 mb-5",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Item */ .Z.Item, {
                                        eventKey: "0",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Header */ .Z.Header, {
                                                children: "How Does a Silver Price Calculator Work?"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Body */ .Z.Body, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                        children: "A silver rate calculator is a simple yet effective digital tool that uses your inputs, such as the purity and weight of silver, to calculate the current value. It factors in the silver market rate and gives you a quick estimate. Here's how it typically works:"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("ul", {
                                                        style: {
                                                            paddingLeft: "2rem",
                                                            paddingBottom: "10px"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("li", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                                                        children: "Weight of Silver:"
                                                                    }),
                                                                    " You enter the weight of your silver item in grams."
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("li", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                                                        children: "Purity Level:"
                                                                    }),
                                                                    " Choose the purity level, like 999 (pure silver) or 925 (sterling silver)."
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("li", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                                                        children: "Live Silver Rate:"
                                                                    }),
                                                                    " The tool fetches or allows entry of the current market rate of silver per gram."
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("li", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                                                        children: "Calculation:"
                                                                    }),
                                                                    " The calculator multiplies the weight by the current rate and applies the purity factor to provide the estimated value."
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                        children: "This helps buyers, sellers, and investors get a close approximation of how much their silver item is worth on any given day."
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Item */ .Z.Item, {
                                        eventKey: "1",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Header */ .Z.Header, {
                                                children: "Different Purities Used in a Silver Cost Calculator"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Body */ .Z.Body, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                        children: "The silver price calculator allows you to choose among various purities. Purity impacts the final value of silver significantly. Here are the common grades:"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h5", {
                                                        children: "999 Silver (Fine Silver)"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                                        children: [
                                                            "This is the purest form of silver, containing 99.9% silver content. It is typically used for",
                                                            " ",
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                                    href: "https://sencogoldanddiamonds.com/jewellery/category/coins-and-bars",
                                                                    children: "coins"
                                                                })
                                                            }),
                                                            ", bars, and investments. Items made from 999 silver yield a higher estimated value in calculators."
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h5", {
                                                        children: "925 Silver (Sterling Silver)"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                        children: "This is the most widely used grade for jewellery and decorative items. It consists of 92.5% silver and 7.5% of other metals (often copper). A 925 purity selection in the calculator gives a slightly lower estimate than pure silver, but is still highly valued."
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h5", {
                                                        children: "Other Purity Grades"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                        children: "Purities like 900 or 800 are used in specific traditional or antique items. You may also find silverware or imported goods marked with these grades, and calculators may provide custom options for such cases."
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                        children: "By selecting the appropriate purity, you ensure that the calculator reflects a realistic valuation."
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Item */ .Z.Item, {
                                        eventKey: "2",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Header */ .Z.Header, {
                                                children: "Benefits of Using a Silver Rate Calculator"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Body */ .Z.Body, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                        children: "Using a silver cost calculator offers various practical advantages for buyers, sellers, and investors:"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                                                children: "1. Instant Valuation:"
                                                            }),
                                                            " No need to wait or manually calculate. You receive real-time estimates instantly, helping you stay updated with market trends."
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                                                children: "2. Accuracy and Transparency:"
                                                            }),
                                                            " The calculator gives consistent results using current rates, helping you avoid price disputes when selling or buying silver."
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                                                children: "3. Financial Planning:"
                                                            }),
                                                            " Whether you're pledging silver for a loan or planning to invest, an estimate helps you budget effectively."
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                                                children: "4. Comparison Shopping:"
                                                            }),
                                                            " You can compare prices from different sellers or platforms to ensure you're not overpaying or underselling."
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                                                children: "5. Easy to Use:"
                                                            }),
                                                            " The interface is usually straightforward, requiring minimal details like weight, purity, and rate per gram."
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                        children: "Whether you are a casual buyer or a seasoned investor, this tool can improve decision-making significantly."
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Item */ .Z.Item, {
                                        eventKey: "3",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Header */ .Z.Header, {
                                                children: "How to Use a Silver Value Calculator Online"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Body */ .Z.Body, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                        children: "Using a silver value calculator online is quick and hassle-free. Many websites offer this feature, including financial service platforms. Here's a step-by-step guide:"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("ul", {
                                                        style: {
                                                            paddingLeft: "2rem",
                                                            paddingBottom: "10px"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("li", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                                                        children: "Enter the Weight:"
                                                                    }),
                                                                    " Add the weight of your silver item in grams."
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("li", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                                                        children: "Select Purity:"
                                                                    }),
                                                                    " Choose the purity level (e.g., 925 for sterling silver)."
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("li", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                                                        children: "Enter or Use Current Silver Rate:"
                                                                    }),
                                                                    " Some calculators autofill the live rate; others may require manual input."
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("li", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                                                        children: "Making Charges (Optional):"
                                                                    }),
                                                                    " For",
                                                                    " ",
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                                            href: "https://sencogoldanddiamonds.com/jewellery/category/gift-silver",
                                                                            children: "silver jewellery"
                                                                        })
                                                                    }),
                                                                    ", you may include making charges per gram if relevant."
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("li", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                                                        children: "GST (if applicable):"
                                                                    }),
                                                                    " Usually 3%, calculated on the total amount."
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("li", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                                                        children: "Calculate:"
                                                                    }),
                                                                    " The calculator shows the estimated value instantly."
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                                                children: "Example:"
                                                            }),
                                                            " If you have a 50-gram silver item of 925 purity, and the live rate per gram is ₹70 (approx.), the calculator computes:"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                        children: "50 \xd7 ₹70 \xd7 92.5% = ₹3,237.50 (excluding taxes or charges)."
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                        children: "This tool is especially useful when comparing offers or evaluating your silver's worth before transactions."
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                                            children: "Disclaimer"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                        children: "The results from any silver calculation tool are indicative in nature. Actual prices may vary due to physical inspection, design, additional charges, and market fluctuations. The calculator is intended for informational purposes only. It does not serve as financial or investment advice, nor is it a certified valuation tool."
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                        children: "Users must verify final rates and conditions with trusted jewellers or financial institutions. The estimates generated are based on user inputs and market rates available at the time of usage. The provider of the calculator is not responsible for any discrepancies, errors, or outcomes arising from its use."
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Item */ .Z.Item, {
                                        eventKey: "4",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Header */ .Z.Header, {
                                                children: "FAQs"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Body */ .Z.Body, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
                                                        children: "How does a silver by the gram price calculator work?"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                        children: "A silver by the gram calculator multiplies the silver’s weight by the current price per gram and adjusts the result based on the purity level. It gives you an approximate market value for your silver item."
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
                                                        children: "What is the formula used to calculate silver price?"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                        children: "The formula most commonly used in a silver price today calculator is:"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                        children: "Estimated Price = Weight (in grams) \xd7 Market Rate per gram \xd7 Purity Factor"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                        children: "If applicable, you can add making charges and GST separately."
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
                                                        children: "Does silver price differ as per purity?"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                        children: "Yes, purity directly affects the price. 999 silver has the highest value, followed by 925 (sterling) and lower grades. The chandi calculator adjusts the result based on the selected purity."
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
                                                        children: "What is the silver cost per gram?"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                        children: "The silver cost per gram varies daily and depends on global market trends, demand-supply conditions, and currency exchange rates. Most calculators auto-update the latest price or allow manual entry for accuracy."
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
                                                        children: "Do silver price calculators include GST?"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                        children: "Some calculators include GST (usually 3%) in the final total, especially if making charges are also added. Always check whether the GST is added separately or already included in the displayed amount."
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (PriceCalculator);


/***/ }),

/***/ 2505:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"breakdown":"price-calculator_breakdown___jHis","breakdown-row":"price-calculator_breakdown-row__RsxC8","calculating_heading_main":"price-calculator_calculating_heading_main__2b_so","calculating_heading":"price-calculator_calculating_heading__jF_Wv","calculator_card":"price-calculator_calculator_card__gMEa_","input_group":"price-calculator_input_group__TO7Jq","text_input":"price-calculator_text_input__p6Lt0","pleft":"price-calculator_pleft__8iM6l","arrow_swip":"price-calculator_arrow_swip__IG4SS","calculate_btn":"price-calculator_calculate_btn__5Z8W4","calculator_output":"price-calculator_calculator_output__mVl66","calculator_footer":"price-calculator_calculator_footer__ef69J","calculator_footer_text_head":"price-calculator_calculator_footer_text_head__e_my7","calculator_bg_main":"price-calculator_calculator_bg_main__7JA8_","calculator_image":"price-calculator_calculator_image__1GBX2","calculator_blink":"price-calculator_calculator_blink__LC1kK","live":"price-calculator_live__DKpOY","calculator_blink_text":"price-calculator_calculator_blink_text__DNWKP","calculator_blink_text_price":"price-calculator_calculator_blink_text_price__HVSbh","blink":"price-calculator_blink__daDqP","blinkn":"price-calculator_blinkn__BLPaA"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8523,4766,5675,9915,2640,3913,536,486,6646,1251,9774,2888,179], function() { return __webpack_exec__(67761); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);